export default "__VITE_ASSET__Helw47$z__"